import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";

const OpenHouseDeleteModal = ({ openHouse, onDelete, onClose }) => (
  <Modal
    show={Boolean(openHouse)}
    onHide={onClose}
    containerClassName="!tw-z-3000"
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="Delete Open House" closeButton />

    <Modal.Body className="tw-flex tw-flex-col tw-items-center tw-gap-[24px]">
      <Typography variant="body-m">
        {(openHouse?.attendees || openHouse?.leads) > 0
          ? `This Open House cannot be deleted because it has ${openHouse.attendees || openHouse.leads} attendees. Only Open Houses with no attendees can be deleted.`
          : "Are you sure you want to delete this Open House?"}
      </Typography>
    </Modal.Body>

    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
      <Button size="medium" schema="secondary" onClick={onClose}>
        {openHouse?.attendees || openHouse?.leads ? "Close" : "Cancel"}
      </Button>
      {(openHouse?.attendees || openHouse?.leads) === 0 && (
        <Button size="medium" schema="warning" onClick={onDelete}>
          Delete
        </Button>
      )}
    </Modal.Footer>
  </Modal>
);

OpenHouseDeleteModal.propTypes = {
  openHouse: PropTypes.shape().isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default OpenHouseDeleteModal;
